import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import RetailDeliveryFeeItem from 'components/FrictionlessCheckout/CostSummary/RetailDeliveryFeeItem/RetailDeliveryFeeItem';
import withGlobalModals from 'hocs/withGlobalModals';

import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import OrderUtils from 'utils/Order';
import RetailDeliveryFeeItemEN from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_en_US';
import RetailDeliveryFeeItemFR from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_fr_CA';

const { getRDF } = OrderUtils;
const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(RetailDeliveryFeeItemEN, RetailDeliveryFeeItemFR);

const fields = createSelector(
    createStructuredSelector({
        defaultText: getTextFromResource(getText, 'defaultText'),
        qty: (state, ownProps) => {
            const feesAsArray = state.order?.orderDetails?.priceInfo?.fees;
            const priceInfo = ownProps.priceInfo;
            const isCheckout = ownProps.isCheckout;
            const isOrderConfirmation = ownProps.isOrderConfirmation;
            const orderDetails = state.order?.orderDetails;
            const feeAmount = getRDF({
                feesAsArray,
                priceInfo,
                orderDetails,
                isCheckout,
                isOrderConfirmation
            });
            let qtyText = feeAmount;

            if (isCheckout && !feeAmount) {
                qtyText = getTextFromResource(getText, 'qtyTbd')(state);
            }

            return qtyText;
        },
        visible: (state, ownProps) => {
            const hasShippingGroups = state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries?.length;

            if (!hasShippingGroups) {
                return false;
            }

            const shippingGroupAddress = state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries[0]?.shippingGroup?.address || {};
            const { postalCode: shippingPostalCode = '', state: shippingState = '' } = shippingGroupAddress;
            const feesAsArray = state.order?.orderDetails?.priceInfo?.fees;
            const priceInfo = ownProps.priceInfo;
            const isCheckout = ownProps.isCheckout;
            const isOrderConfirmation = ownProps.isOrderConfirmation;
            const orderDetails = state.order?.orderDetails;
            const feeAmount = getRDF({
                feesAsArray,
                priceInfo,
                orderDetails,
                isCheckout,
                isOrderConfirmation
            });

            return Boolean(shippingPostalCode !== '' && shippingState !== '' && feeAmount);
        }
    }),
    ({ defaultText, qty, visible }) => ({ defaultText, qty, visible })
);

const withRetailDeliveryFeeItemProps = wrapHOC(connect(fields));

const WrappedRetailDeliveryFeeItem = withGlobalModals(withRetailDeliveryFeeItemProps(RetailDeliveryFeeItem));

export default WrappedRetailDeliveryFeeItem;
